import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import { UIProvider } from './contexts/UIContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/chat/Dashboard';
import './App.css';

function LandingPage() {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <h1 className="text-3xl font-bold text-gray-900">
            FlekStore Support
          </h1>
          <div className="space-x-4">
            <Link 
              to="/login" 
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors inline-block"
            >
              Login
            </Link>
            <Link 
              to="/register" 
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors inline-block"
            >
              Register
            </Link>
          </div>
        </div>
      </header>
      
      <main>
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <div className="border-4 border-dashed border-gray-200 rounded-lg p-8">
              <div className="text-center">
                <h2 className="text-2xl font-semibold text-gray-700 mb-4">
                  Welcome to FlekStore Support
                </h2>
                <p className="text-gray-600 mb-8">
                  Get quick support and stay connected with our community
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                  <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      ⚡ Quick Support
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Get instant help from our support team anytime you need it
                    </p>
                  </div>

                  <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      📁 Easy File Sharing
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Share screenshots and documents to help us assist you better
                    </p>
                  </div>

                  <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      💬 Stay Connected
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Join our community and get updates on new features
                    </p>
                  </div>
                </div>
                
                <div className="mt-12 space-y-4">
                  <h3 className="text-xl font-medium text-gray-900">
                    Get Started
                  </h3>
                  <div className="flex justify-center space-x-4">
                    <Link 
                      to="/register" 
                      className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors text-lg font-medium"
                    >
                      Create Account
                    </Link>
                    <Link 
                      to="/login" 
                      className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors text-lg font-medium"
                    >
                      Sign In
                    </Link>
                  </div>
                </div>
                
                <div className="mt-8">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">
                    Join Our Community
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                    <a
                      href="https://t.me/flekstore_com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      📱 Telegram Group
                    </a>
                    <a
                      href="https://t.me/flek_support"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
                    >
                      💬 Official support TG bot
                    </a>
                  </div>
                  <p className="text-gray-500 text-sm mt-4">
                    Visit <a href="https://flekstore.com/TG" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">flekstore.com/TG</a> for more information
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <UIProvider>
        <AuthProvider>
          <ChatProvider>
            <Router>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Router>
          </ChatProvider>
        </AuthProvider>
      </UIProvider>
    </div>
  );
}

export default App;
